import React from "react";

const CrossIcon = ({ height = 24, width = 24, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.5"
        d="M15.4697 7.46973C15.7626 7.17684 16.2373 7.17684 16.5302 7.46973C16.8231 7.76263 16.8231 8.2374 16.5302 8.53028L13.0605 12L16.5302 15.4697C16.8231 15.7626 16.8231 16.2374 16.5302 16.5303C16.2373 16.8232 15.7626 16.8231 15.4697 16.5303L11.9999 13.0606L8.53022 16.5303C8.23734 16.8232 7.76257 16.8231 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L10.9394 12L7.46967 8.53028C7.17678 8.23738 7.17678 7.76262 7.46967 7.46973C7.76256 7.17684 8.23732 7.17684 8.53022 7.46973L11.9999 10.9395L15.4697 7.46973Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CrossIcon;
